module.exports = __webpack_public_path__ + "img/generalSettingsActive.42d28923.svg";